import request from '../config/axiosConfig';
import { GET_LIST_MENUS, GET_ALL_MENUS, GET_MENU_INFO, CREATE_MENU, UPDATE_MENU, DELETE_MENU } from '../constants/menuApiEndPoint';

export const getMenus = async (params) => {
  return (
    await request({
      url: GET_LIST_MENUS,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getAllMenus = async () => {
  return (
    await request({
      url: GET_ALL_MENUS,
      method: 'GET',
    })
  )?.data;
};

export const getMenuInfo = async (id) => {
  return (
    await request({
      url: GET_MENU_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createMenu = async (data) => {
  return (
    await request({
      url: CREATE_MENU,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateMenu = async (id, data) => {
  return (
    await request({
      url: UPDATE_MENU,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteMenu = async (id) => {
  return (
    await request({
      url: DELETE_MENU,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
